import { Dialog, DialogContent, Button, DialogActions } from "@mui/material";
import StampingOrderTable from "./StampingOrderTable";
import { useSelector } from "react-redux";

const StampingOrderMainModal = ({ open, handleClose }) => {
  const { defaultDataPedido } = useSelector(({ pedido }) => pedido);
  return (
    <Dialog fullWidth maxWidth="xl" open={open} onClose={handleClose}>
      <DialogContent>
        <StampingOrderTable defaultDataPedido={defaultDataPedido} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color={"secondary"} variant="contained">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default StampingOrderMainModal;
